// Heuristic bot/crawler detection from the browser's own User-Agent, used to
// gate the analytics pipeline (see Tracker.ts): search engine crawlers,
// uptime/SEO monitors and headless automation tools all identify themselves
// in the UA string, so a substring match is enough to keep them out of the
// event queue without any network round-trip. Not meant to be airtight (a
// bot can always spoof its UA) — core-input applies the same check
// server-side (see that repo's src/botDetect.ts) as defense in depth.
var BOT_UA_PATTERN = /bot|crawler|crawling|spider|slurp|facebookexternalhit|ia_archiver|archive\.org|headless|phantomjs|selenium|puppeteer|playwright|lighthouse|pingdom|uptimerobot|semrush|ahrefs|mj12|dotbot|petalbot|bytespider|linkedinbot|discordbot|slackbot|twitterbot|applebot|duckduckbot|baiduspider|yandex|sogou|exabot/i;
export function isLikelyBot(userAgent) {
    if (!userAgent)
        return false;
    return BOT_UA_PATTERN.test(userAgent);
}
